import { useState } from 'react';

export const useTeamMemberStates = () => {
  const [administrators, setAdministrators] = useState<string[]>([]);
  const [contributors, setContributors] = useState<string[]>([]);
  const [customers, setCustomers] = useState<string[]>([]);

  return {
    administrators,
    setAdministrators,
    contributors,
    setContributors,
    customers,
    setCustomers,
  };
};
